import apiClient from './api'
import type {
  ApiResponse,
  DashboardOverview,
  ChartSeries,
  Task,
  Contract,
  TechnicianRankingRow,
  TechnicianRankingQuery,
} from '@/types'

// 1:1 with Schema_Specification Section 4.2 (dashboard).
export const dashboardApi = {
  getOverview: (period?: string) =>
    apiClient
      .get<ApiResponse<DashboardOverview>>('/dashboard/overview', {
        params: period ? { period } : undefined,
      })
      .then(r => r.data),

  getInterventions7Days: () =>
    apiClient
      .get<ApiResponse<ChartSeries>>('/dashboard/interventions-7days')
      .then(r => r.data),

  getJobsByCategory: (period?: string) =>
    apiClient
      .get<ApiResponse<ChartSeries>>('/dashboard/jobs-by-category', {
        params: period ? { period } : undefined,
      })
      .then(r => r.data),

  getPendingTasks: (limit?: number) =>
    apiClient
      .get<ApiResponse<Task[]>>('/dashboard/pending-tasks', {
        params: limit ? { limit } : undefined,
      })
      .then(r => r.data),

  getContractsToRenew: () =>
    apiClient
      .get<ApiResponse<Contract[]>>('/dashboard/contracts-to-renew')
      .then(r => r.data),

  getTechnicianRanking: (q: TechnicianRankingQuery = {}) =>
    apiClient
      .get<ApiResponse<TechnicianRankingRow[]>>(
        '/dashboard/technician-ranking',
        { params: q }
      )
      .then(r => r.data),
}

export default dashboardApi
